// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3c0285ed","61":"25689c06","376":"e6f9a6a0","471":"d86edb4e"}[chunkId] + ".chunk.js";
};